(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CHR003Review"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('chr-review-carousel')) return;

    class ChrReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.chr-rv__stage');
        this.slides = Array.from(this.querySelectorAll('.chr-rv__slide'));
        this.n = this.slides.length;
        if (!this.stage || !this.n) return;

        this.cur = this.querySelector('[data-cur]');
        this.fill = this.querySelector('[data-fill]');
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = parseInt(this.dataset.speed, 10) || 6000;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.designMode = !!(window.Shopify && Shopify.designMode);

        this.active = 0;
        this.state = this.slides.map(() => ({ p: null, cls: '' }));
        this.drag = null;
        this.raf = 0;
        this.timer = 0;
        this.flags = { hover: false, focus: false, view: true };
        this.ac = new AbortController();
        this.bind();
        this.layout();
        this.classList.add('is-ready');
        this.restart();
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        clearTimeout(this.timer);
        cancelAnimationFrame(this.raf);
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
      }

      /* ---------- Ölçü & yerleşim ---------- */
      measure() {
        const cs = getComputedStyle(this);
        this.S = parseFloat(cs.getPropertyValue('--side-scale')) || .82;
        const gap = parseFloat(cs.getPropertyValue('--gap')) || 0;
        const cw = this.slides[0].offsetWidth || 300;
        this.step1 = cw / 2 + cw * this.S / 2 + gap;
        this.step2 = cw * this.S + gap;
      }

      offsetOf(i, amb) {
        const n = this.n;
        let o = ((i - this.active) % n + n) % n;
        if (o > n / 2) o -= n;
        else if (n % 2 === 0 && o === n / 2 && amb < 0) o = -o;
        return o;
      }

      place(i, p) {
        const el = this.slides[i], st = this.state[i];
        const a = Math.abs(p), S = this.S;
        const sc = a <= 1 ? 1 - (1 - S) * a : S;
        let x = a <= 1 ? a * this.step1 : this.step1 + (a - 1) * this.step2;
        if (p < 0) x = -x;
        const op = a <= 1 ? 1 : Math.max(0, 1 - (a - 1) * 2);
        el.style.transform = `translate3d(${x.toFixed(1)}px,0,0) scale(${sc.toFixed(4)})`;
        el.style.opacity = op < 1 ? op.toFixed(3) : '';
        el.style.setProperty('--k', (1 - Math.min(a, 1)).toFixed(3));
        const cls = a < .5 ? 'is-active' : a < 1.5 ? 'is-side' : (op < .05 ? 'is-off' : '');
        if (cls !== st.cls) {
          if (st.cls) el.classList.remove(st.cls);
          if (cls) el.classList.add(cls);
          el.style.zIndex = cls === 'is-active' ? '3' : cls === 'is-side' ? '2' : '1';
          el.setAttribute('aria-hidden', cls === 'is-active' ? 'false' : 'true');
          st.cls = cls;
        }
        st.p = p;
      }

      render(frac = 0, animate = false, amb = 1) {
        for (let i = 0; i < this.n; i++) {
          const p = this.offsetOf(i, amb) + frac;
          const prev = this.state[i].p;
          if (prev === p) continue;
          if (animate && prev !== null && Math.abs(p - prev) > 1.5) {
            /* döngü sarması: görünmez uçtan içeri kayarak gelir */
            const el = this.slides[i];
            el.style.transition = 'none';
            this.place(i, p + (p > prev ? 1 : -1));
            void el.offsetWidth;
            el.style.transition = '';
          }
          this.place(i, p);
        }
        if (this.cur) this.cur.textContent = String(this.active + 1).padStart(2, '0');
        if (this.fill) this.fill.style.transform = `scaleX(${(this.active + 1) / this.n})`;
      }

      layout() {
        this.classList.add('is-instant');
        this.measure();
        this.state.forEach((s) => (s.p = null));
        this.render();
        void this.offsetWidth;
        requestAnimationFrame(() => this.classList.remove('is-instant'));
      }

      go(target, dir) {
        if (this.n < 2) return;
        this.active = ((target % this.n) + this.n) % this.n;
        this.render(0, true, dir > 0 ? -1 : 1);
        this.restart();
      }
      next() { this.go(this.active + 1, 1); }
      prev() { this.go(this.active - 1, -1); }

      /* ---------- Sürükleme (touch + mouse ortak) ---------- */
      dragStart(x, y) {
        this.drag = { x, y, dx: 0, locked: false, dead: false, hist: [[x, performance.now()]] };
      }
      dragMove(x, y) {
        const d = this.drag;
        if (!d || d.dead) return false;
        const dx = x - d.x, dy = y - d.y;
        if (!d.locked) {
          if (Math.abs(dx) < 7 && Math.abs(dy) < 7) return false;
          if (Math.abs(dy) > Math.abs(dx) * .9) { d.dead = true; return false; } /* dikey → sayfa kaysın */
          d.locked = true;
          this.classList.add('is-drag');
          this.stop();
        }
        d.dx = dx;
        const now = performance.now();
        d.hist.push([x, now]);
        while (d.hist.length > 2 && now - d.hist[0][1] > 120) d.hist.shift();
        if (!this.raf) {
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            if (!this.drag || !this.drag.locked) return;
            const f = Math.max(-1, Math.min(1, this.drag.dx / this.step1));
            this.render(f, false, f > 0 ? -1 : 1);
          });
        }
        return true;
      }
      dragEnd(cancelled) {
        const d = this.drag;
        this.drag = null;
        cancelAnimationFrame(this.raf); this.raf = 0;
        if (!d || !d.locked) return;
        this.classList.remove('is-drag');
        this.suppress = true;
        setTimeout(() => (this.suppress = false), 80);
        const a = d.hist[0], b = d.hist[d.hist.length - 1];
        const v = (b[0] - a[0]) / Math.max(1, b[1] - a[1]);
        const f = d.dx / this.step1;
        const flick = Math.abs(v) > .3 && Math.abs(d.dx) > 18;
        if (!cancelled && (f < -.18 || (flick && v < 0))) this.next();
        else if (!cancelled && (f > .18 || (flick && v > 0))) this.prev();
        else { this.render(0, true, f > 0 ? -1 : 1); this.restart(); }
      }

      /* ---------- Otomatik ilerleme ---------- */
      stop() { clearTimeout(this.timer); this.timer = 0; }
      restart() {
        this.stop();
        const f = this.flags;
        if (this.autoplay && this.n > 1 && !this.reduced && !this.designMode && !f.hover && !f.focus && f.view && !this.drag && !document.hidden) {
          this.timer = setTimeout(() => this.next(), this.speed);
        }
      }

      /* ---------- Olaylar ---------- */
      bind() {
        const sig = { signal: this.ac.signal };
        const on = (el, ev, fn, o) => el.addEventListener(ev, fn, Object.assign({}, sig, o));
        const st = this.stage;

        this.querySelectorAll('.chr-rv__btn').forEach((b) =>
          on(b, 'click', () => (b.dataset.dir === '1' ? this.next() : this.prev()))
        );
        on(st, 'keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
        });
        on(st, 'click', (e) => {
          if (this.suppress) { e.preventDefault(); e.stopPropagation(); return; }
          const s = e.target.closest('.chr-rv__slide');
          const i = this.slides.indexOf(s);
          if (i < 0) return;
          const o = this.offsetOf(i, 1);
          if (o !== 0 && Math.abs(o) <= 1) this.go(this.active + o, o);
        }, { capture: true });

        /* dokunmatik */
        on(st, 'touchstart', (e) => {
          if (this.n < 2 || e.touches.length > 1) { this.dragEnd(true); return; }
          this.dragStart(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: true });
        on(st, 'touchmove', (e) => {
          if (!this.drag) return;
          if (e.touches.length > 1) { this.dragEnd(true); return; }
          if (this.dragMove(e.touches[0].clientX, e.touches[0].clientY) && e.cancelable) e.preventDefault();
        }, { passive: false });
        on(st, 'touchend', () => this.dragEnd(false), { passive: true });
        on(st, 'touchcancel', () => this.dragEnd(true), { passive: true });

        /* mouse / kalem */
        on(st, 'pointerdown', (e) => {
          if (e.pointerType === 'touch' || this.n < 2 || e.button !== 0) return;
          e.preventDefault();
          this.dragStart(e.clientX, e.clientY);
          try { st.setPointerCapture(e.pointerId); } catch (_) {}
        });
        on(st, 'pointermove', (e) => { if (e.pointerType !== 'touch' && this.drag) this.dragMove(e.clientX, e.clientY); });
        on(st, 'pointerup', (e) => { if (e.pointerType !== 'touch') this.dragEnd(false); });
        on(st, 'pointercancel', (e) => { if (e.pointerType !== 'touch') this.dragEnd(true); });

        /* trackpad yatay kaydırma */
        let wheelAt = 0;
        on(st, 'wheel', (e) => {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 12) return;
          e.preventDefault();
          const now = performance.now();
          if (now - wheelAt < 450) return;
          wheelAt = now;
          e.deltaX > 0 ? this.next() : this.prev();
        }, { passive: false });

        /* otomatik ilerleme durdurucular */
        on(this, 'mouseenter', () => { this.flags.hover = true; this.stop(); });
        on(this, 'mouseleave', () => { this.flags.hover = false; this.restart(); });
        on(this, 'focusin', () => { this.flags.focus = true; this.stop(); });
        on(this, 'focusout', () => { this.flags.focus = false; this.restart(); });
        on(document, 'visibilitychange', () => this.restart());
        if (this.autoplay) {
          this.io = new IntersectionObserver((en) => { this.flags.view = en[0].isIntersecting; this.restart(); }, { threshold: .25 });
          this.io.observe(this);
        }

        /* yalnızca genişlik değişince yeniden ölç */
        let lastW = st.clientWidth, rt = 0;
        this.ro = new ResizeObserver(() => {
          const w = st.clientWidth;
          if (w === lastW) return;
          lastW = w;
          clearTimeout(rt);
          rt = setTimeout(() => this.layout(), 120);
        });
        this.ro.observe(st);

        /* tema düzenleyici: blok seçilince o yoruma git */
        on(document, 'shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) this.go(i, this.offsetOf(i, 1) >= 0 ? 1 : -1);
        });
      }
    }

    customElements.define('chr-review-carousel', ChrReviewCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CHR003Triptik"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.CX3) return;

    const init = (root) => {
      if (!root || root.__cx3) return;
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      if (!tabs.length) return;

      const sync = (panel) => {
        const rail = panel && panel.querySelector('[data-rail]');
        if (!rail) return;
        const max = rail.scrollWidth - rail.clientWidth;
        const bar = panel.querySelector('[data-progress]');
        const prev = panel.querySelector('[data-prev]');
        const next = panel.querySelector('[data-next]');
        if (bar) {
          bar.parentNode.hidden = max <= 2;
          bar.style.transform = `scaleX(${Math.min(1, (rail.scrollLeft + rail.clientWidth) / rail.scrollWidth)})`;
        }
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
      };

      const select = (i, focus) => {
        tabs.forEach((t, k) => {
          const on = k === i;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          panels[k].hidden = !on;
        });
        const rail = panels[i].querySelector('[data-rail]');
        if (rail) rail.scrollLeft = 0;
        if (focus) tabs[i].focus();
        tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        sync(panels[i]);
      };

      const keys = { ArrowRight: 1, ArrowLeft: -1 };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(i));
        t.addEventListener('keydown', (e) => {
          let j = null;
          if (e.key in keys) j = (i + keys[e.key] + tabs.length) % tabs.length;
          else if (e.key === 'Home') j = 0;
          else if (e.key === 'End') j = tabs.length - 1;
          if (j === null) return;
          e.preventDefault();
          select(j, true);
        });
      });

      panels.forEach((p) => {
        const rail = p.querySelector('[data-rail]');
        if (!rail) return;
        const go = (d) => rail.scrollBy({ left: d * rail.clientWidth * 0.9, behavior: 'smooth' });
        p.querySelector('[data-prev]')?.addEventListener('click', () => go(-1));
        p.querySelector('[data-next]')?.addEventListener('click', () => go(1));
        let ticking = false;
        rail.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => { sync(p); ticking = false; });
        }, { passive: true });
      });

      const visible = () => panels.find((p) => !p.hidden);
      new ResizeObserver(() => sync(visible())).observe(root);

      root.__cx3 = { select };
    };

    const all = () => document.querySelectorAll('[data-cx3]').forEach(init);
    window.CX3 = { init };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
    else all();

    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-cx3]')));
    document.addEventListener('shopify:block:select', (e) => {
      const tab = document.querySelector(`[role="tab"][data-block="${e.detail.blockId}"]`);
      const root = tab && tab.closest('[data-cx3]');
      if (!root || !root.__cx3) return;
      root.__cx3.select([...root.querySelectorAll('[role="tab"]')].indexOf(tab));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
